import http from '@/util/http';

export default {
	situationRingPermissionValidation() {
		return http.get('AddSetting/api/situationRing/permissionValidation');
	},
	receiveRingPermissionValidation() {
		return http.get('AddSetting/api/receiveRing/permissionValidation');
	},
	getNetSchedulingConfig() {
		return http.get('AddSetting/api/netScheduling/getNetSchedulingConfig');
	},
	checkNetSchedulingPassword(payload) {
		return http.post('AddSetting/api/netScheduling/checkNetSchedulingPassword', payload);
	},
	changeNetSchedulingConfig(payload) {
		return http.post('AddSetting/api/netScheduling/changeNetSchedulingConfig', payload);
	}
}


// WEBPACK FOOTER //
// ./src/api/addSetting/addSettingApi.js